import $ = require('jquery');
import 'preload-js';
import ProductView = require("./view/ProductView");
import AbstractView = require("./view/abstract/AbstractView");
import DesignView = require("./view/DesignView");
import PerformanceView = require("./view/PerformanceView");
import AuraView = require("./view/AuraView");
import AudioView = require("./view/AudioView");
import PlayerView = require("./view/PlayerView");
import LoadingView = require("./view/LoadingView");
import ScrollView = require("./view/ScrollView");
import DisplayView = require("./view/DisplayView");
import CoolingView = require("./view/CoolingView");
import KVView = require("./view/KVView");
import Config = require("./config/Config");
import SoftwareView = require("./view/SoftwareView");
import QualityView = require("./view/QualityView");
import AccessoriesView = require("./view/AccessoriesView");

module IndexPage {
    "use strict";
    $(function () {

        Config.init();

        createLoadingView();
        createScrollView();
        loadYTApi();

        $(window).on("resize", onWindowResize);
        onWindowResize(null);
    });


    function onWindowResize(event: JQuery.Event) {

        fixAsusWrapper();
        if (renderViews && renderViews.length > 0) {
            for (let key in renderViews) {
                if (renderViews.hasOwnProperty(key)) {
                    renderViews[key].resize();
                }
            }
        }
    }

    function fixAsusWrapper() {
        let baseW: number = $("#special-sectionOverview, #sectionOverview").width();
        let targetX: number = (baseW - window.innerWidth) * 0.5;
        $("#fixASUSWrapper").css({
            'left': targetX + 'px',
            'width': window.innerWidth + 'px'
        });
    }


    /*
    * YoutubeApi
    * */
    function loadYTApi() {
        const myDoc = (<any>window).document;
        let playerApiScript = myDoc.createElement('script');
        playerApiScript.type = 'text/javascript';
        playerApiScript.src = 'https://www.youtube.com/iframe_api';
        myDoc.body.appendChild(playerApiScript);
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(playerApiScript, firstScriptTag);
        (<any>window).onYouTubeIframeAPIReady = () => {
            console.log("Youtube Api Loaded!!!!");
            loadAssets();
        };
    }


    /*
    * AssetsLoader
    * */
    let loader: createjs.LoadQueue;
    let assetArr: string[] = [
        "assets/img/kv/bg.jpg",
        "assets/img/kv/product-l.png",
        "assets/img/kv/product-r.png"
    ];

    function loadAssets() {

        let loadArr: any[] = [];
        for (let i: number = 0; i < assetArr.length; i++) {
            loadArr.push({id: assetArr[i], src: assetArr[i]});
        }

        loader = new createjs.LoadQueue();
        loader.on("progress", (event: any) => {
            let percent: number = Math.floor(event.loaded * 100);
            loadingView.onProgress(percent);
        });
        loader.on("complete", () => {
            createPlayerView();
            createView();
            loadingView.transitionOut();
        });
        loader.loadManifest(loadArr);
    }


    /*
    * Views
    * */
    let loadingView: LoadingView;

    function createLoadingView() {
        loadingView = new LoadingView(-1, $("#rog-loading"));
    }

    let playerView: PlayerView;

    function createPlayerView() {
        playerView = new PlayerView(100, $("#rog-youtube"));
    }


    let renderViews: any[];
    let viewData: any[] = [
        {tagName: "#rog-kv", class: KVView, target: null},
        {tagName: "#rog-product", class: ProductView, target: null},
        {tagName: "#rog-design", class: DesignView, target: null},
        {tagName: "#rog-display", class: DisplayView, target: null},
        {tagName: "#rog-performance", class: PerformanceView, target: null},
        {tagName: "#rog-cooling", class: CoolingView, target: null},
        {tagName: "#rog-quality", class: QualityView, target: null},
        {tagName: "#rog-aura", class: AuraView, target: null},
        {tagName: "#rog-audio", class: AudioView, target: null},
        {tagName: "#rog-software", class: SoftwareView, target: null},
        {tagName: "#rog-accessories", class: AccessoriesView, target: null}

    ];

    function createView() {

        renderViews = [];
        for (let i: number = 0; i < viewData.length; i++) {

            let $target: JQuery = $(viewData[i]["tagName"]);
            let ViewClass: any = viewData[i]["class"];
            let targetView: any = new ViewClass(i, $target);
            viewData[i]["target"] = targetView;
            renderViews.push(targetView);
            targetView.emitter.on(AbstractView.ViewEvent.PlayVideo, onPlayVideoStatus);
            targetView.emitter.on(AbstractView.ViewEvent.ScrollTo, (targetTop: number) => {
                scrollView.scrollTo(targetTop);
            });
        }

        $(".topBtn").on("click tap", (event: JQuery.Event) => {
            event.preventDefault();
            scrollView.scrollTo(0);
        });

        onWindowScroll(scrollView.getScrollTop());
        onWindowResize(null);
    }

    function onPlayVideoStatus(code: string): void {
        console.log("youtube", code);
        playerView.playVideo(code);
    }

    let scrollView: ScrollView;
    let scrollTop: number;

    function createScrollView(): void {
        scrollView = new ScrollView($(window), $("body,html"));
        scrollView.emitter.on(ScrollView.ScrollEvent.ON_SCROLL, onWindowScroll);
        scrollTop = scrollView.getScrollTop();
    }

    function onWindowScroll(result: number): void {
        scrollTop = result;
        if (scrollTop > 200) {
            $(".topBtn").addClass("active");
        } else {
            $(".topBtn").removeClass("active");
        }
        // console.log("scrollTop", scrollTop);
        if (renderViews && renderViews.length > 0) {
            for (let key in renderViews) {
                if (renderViews.hasOwnProperty(key)) {
                    renderViews[key].onScroll(scrollTop);
                }
            }
        }
    }

    function scrollToElement(target: JQuery) {
        scrollView.scrollToElement(target, 0);
    }


}